var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Report(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-report",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M11.51,18H6.493a2.977,2.977,0,0,1-2.1-.86L.88,13.63A2.977,2.977,0,0,1,0,11.51v-5A3.017,3.017,0,0,1,.88,4.39L4.37.88A2.977,2.977,0,0,1,6.49,0h5A3.017,3.017,0,0,1,13.61.88l3.51,3.51A2.983,2.983,0,0,1,18,6.49v5a2.978,2.978,0,0,1-.86,2.12l-3.51,3.51A2.977,2.977,0,0,1,11.51,18Zm-5-16a.993.993,0,0,0-.7.29L2.29,5.79a1.008,1.008,0,0,0-.29.7v5a.993.993,0,0,0,.29.7l3.5,3.521a1.008,1.008,0,0,0,.7.29h5a.993.993,0,0,0,.7-.29L15.71,12.19a.993.993,0,0,0,.29-.7l.02-4.981a.993.993,0,0,0-.29-.7L12.21,2.29a1.008,1.008,0,0,0-.7-.29ZM9.5,13h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,9.5,13ZM8.468,9a.25.25,0,0,1-.248-.22l-.4-3.22a.5.5,0,0,1,.123-.393A.5.5,0,0,1,8.313,5H9.687a.5.5,0,0,1,.37.167.5.5,0,0,1,.123.393l-.4,3.22A.25.25,0,0,1,9.532,9H8.468Z",
    transform: "translate(3 3)",
    fill: "#02466a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Report);
export default __webpack_public_path__ + "static/media/icon-24-report.d99dfbf7e9dd646c9ef3f0a56a600d06.svg";
export { ForwardRef as ReactComponent };